package fr.frux.feature.notifications

import androidx.compose.runtime.Composable
import androidx.compose.runtime.staticCompositionLocalOf
import androidx.lifecycle.viewmodel.compose.viewModel

/** Contrat de fabrique du [NotificationPreferencesViewModel], honoré par le composition root (#43). */
fun interface NotificationPreferencesViewModelFactory {
    fun create(): NotificationPreferencesViewModel
}

/** Fabrique installée par le composition root ; sans défaut, pour que l'oubli de câblage crie. */
val LocalNotificationPreferencesViewModelFactory =
    staticCompositionLocalOf<NotificationPreferencesViewModelFactory> {
        error(
            "NotificationPreferencesViewModelFactory absente : le composition root doit l'installer " +
                "(cf. FruxCompositionRoot, #43)",
        )
    }

@Composable
fun rememberNotificationPreferencesViewModel(): NotificationPreferencesViewModel {
    val factory = LocalNotificationPreferencesViewModelFactory.current
    return viewModel { factory.create() }
}
